class UrlParams {
  private params: any;
  public props: any;

  constructor() {
    this.params = {};
    this.props = {
			gameName: '',
			operatorName: '',
			channel: 'desktop',
			locale: 'en',
			lobbyURL: '',
			cashierURL: '',
			depositURL: '',
      rulesURL: '',
			currency: 'FUN',
			playMode: 'FUN',
			token: null,
			gameID: '',
			fixedID: '',
			installID: '',
			// optional params
			isFun: -1,
			brandID: '',
			sessionID: '',
			// RNG token that will be forwarded to the RNG for cheating on devmode
			RNGtoken: '',
      noWrapper: false,
      noTopBar: false,
			jurisdiction: '',
			disconnectredirect: '',
		};

    this.getParams();

    const readProps = {
      // mandatory params
      gameID: this.params.gameID,
      operatorName: this.params.operator,
      fixedID: this.params.fixedID,
      installID: this.params.installID,
      channel: this.params.device,
      locale: this.params.lang,
      siteID: this.params.siteID,
      isFun: this.params.funReal,
      brandID: this.params.brandID,
      playToken: this.params.sessionID,
      lobbyURL: this.params.lobbyURL,
			cashierURL: this.params.cashierURL,
      rulesURL: this.params.rulesURL,
      depositURL: this.params.depositURL,
      historyURL: this.params.historyURL,
      endpoint: this.params.endpoint,
      currency: this.params.currency,
      playMode: this.params.playMode,
      // save token if wanted
      RNGtoken: this.params.RNGtoken,
      noWrapper: this.params.noWrapper || false,
      noTopBar: this.params.noTopBar || false,
			jurisdiction: this.params.jurisdiction,
			disconnectredirect: this.params.disconnectredirect,
    };
    // channel is set dinamically
     readProps.channel = 'desktop';
    // add URL read props
    this.props = { ...this.props, ...readProps };
  }

  getParams() {
    const that = this;
    new URL(window.location.href).searchParams.forEach(function (val, key) {
      that.params[key] = decodeURIComponent(val);
    }); 
  }
}

export default UrlParams;